import { Typography } from "@mui/material";
import DesktopBanner from "./DesktopBanner";
import { constants } from "@/environment/constants";

export const banners = [
  <DesktopBanner
    backgroundColor="#D8EEED"
    circleColor="#71C1BD"
    backgroundColor2="#BCE2E0"
    btnColor="#A6D8D6"
    img="/main/6.webp"
    href="/categories/jewelry"
    btnTitle="مشاهده"
    title={
      <>
        <Typography variant="h5" fontWeight={700}>
          اکسسوری و پیرسینگ
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontSize: { xs: "0.9rem", md: "1.0833333333333333rem", lg: "1.2rem" }, maxWidth: { md: "100%", xs: "60%" } }}
        >
          انواع گوشواره، گردنبند، دستبند،... پیرسینگ های متنوع در {constants.siteName}
        </Typography>
      </>
    }
  />,
  <DesktopBanner
    backgroundColor="#FFE7D1"
    circleColor="#E7A66B"
    backgroundColor2="#FFD7B3"
    btnColor="#FFD7B3"
    img="/main/7.webp"
    btnTitle="مشاهده"
    href="/categories/jewelry/women/ring"
    title={
      <>
        <Typography variant="subtitle1" fontWeight={700}>
          انواع
        </Typography>
        <Typography variant="h5">انگشترهای ترند </Typography>
      </>
    }
  />,
  <DesktopBanner
    backgroundColor="#F1E7FE"
    ltr={true}
    circleColor="#A96CF9"
    backgroundColor2="#E2CEFD"
    btnColor="#E2CEFD"
    img="/main/8.webp"
    href="/categories/jewelry/women/necklace"
    btnTitle="مشاهده"
    title={
      <>
        <Typography variant="subtitle1" fontWeight={700}>
          انواع
        </Typography>
        <Typography variant="h5">گردنبندهای ترند </Typography>
      </>
    }
  />,
];
